// extracted by mini-css-extract-plugin
export default {"emptyTableContainer":"EmptyTable_emptyTableContainer__Bctkt","emptyTableDesc":"EmptyTable_emptyTableDesc__AZaks"};